import React from 'react';
import * as styles from './styles.scss';

const ButtonCheckout = ({ className, children, ...props }) => (
    <button
        className={`${styles.checkout}${className ? ` ${className}` : ''}`}
        { ...props }
    >
        {children}
    </button>
);

export default ButtonCheckout;
